import React from 'react'
import Trans from '../atomic/Trans'

const Step1 = ({ formik }) => {
  const getFieldClass = field => {
    return formik.errors[field] ? 'error' : formik.values[field] !== '' ? 'valid' : ''
  }

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="text"
            className={getFieldClass('nome')}
            id="nome"
            name="nome"
            value={formik.values.nome}
            onChange={formik.handleChange}
          />
          <label htmlFor="nome">
            <Trans chiave="Nome*" />
          </label>
          <span className="w-form__error">{formik.errors.nome}</span>
        </div>
      </div>
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="text"
            className={getFieldClass('cognome')}
            id="cognome"
            name="cognome"
            value={formik.values.cognome}
            onChange={formik.handleChange}
          />
          <label htmlFor="cognome">
            <Trans chiave="Cognome*" />
          </label>
          <span className="w-form__error">{formik.errors.cognome}</span>
        </div>
      </div>
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="email"
            id="email"
            name="email"
            className={getFieldClass('email')}
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          <label htmlFor="email">
            <Trans chiave="Email*" />
          </label>
          <span className="w-form__error">{formik.errors.email}</span>
        </div>
      </div>
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="email"
            id="confermaEmail"
            name="confermaEmail"
            className={getFieldClass('confermaEmail')}
            value={formik.values.confermaEmail}
            onChange={formik.handleChange}
          />
          <label htmlFor="conferma_email">
            <Trans chiave="Conferma email*" />
          </label>
          <span className="w-form__error">{formik.errors.confermaEmail}</span>
        </div>
      </div>
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="password"
            id="password"
            name="password"
            className={getFieldClass('password')}
            value={formik.values.password}
            onChange={formik.handleChange}
          />
          <label htmlFor="password">
            <Trans chiave="Password*" />
          </label>
          <span className="w-form__info">
            <Trans
              chiave="La password deve contenere almeno 5 caratteri, di cui almeno uno alfabetico maiuscolo,
            una cifra e un carattere speciale"
            />
          </span>
          <span className="w-form__error">{formik.errors.password}</span>
        </div>
      </div>
      <div className="col-md-6">
        <div className="w-form__field-wrapper">
          <input
            type="password"
            id="confermaPassword"
            name="confermaPassword"
            className={getFieldClass('confermaPassword')}
            value={formik.values.confermaPassword}
            onChange={formik.handleChange}
          />
          <label htmlFor="conferma_password">
            <Trans chiave="Conferma password*" />
          </label>
          <span className="w-form__error">{formik.errors.confermaPassword}</span>
        </div>
      </div>
    </div>
  )
}

export default Step1
